<template>
    <div>
      <div class="page-wrapper">
        <head-view></head-view>
      </div>
      <div class="page-content">
      <!-- <swiper-view></swiper-view> -->
       <home-view></home-view>
       </div>
       <!-- <banner-view></banner-view> -->
        <process-view :appList="appGameData" :tapList="tapGameData"></process-view><!-- 🟩改动：组件绑定传参 --><!-- 游戏推荐 查看所有游戏> -->
       <!-- <process-view></process-view> --><!-- 游戏推荐 查看所有游戏> -->
       <!-- <recommend-view></recommend-view> --><!-- 萌宝推荐 -->
       <footer-view></footer-view><!-- 底部隐私协议等 -->
    </div>
</template>
<script>
import FooterView from './footer/footerView.vue';
//import BannerView from './banner/bannerView.vue'
import HeadView from './header/headView.vue'
import HomeView from './HomeView.vue';
import ProcessView from './process/processView.vue';
//import RecommendView from './recommend/recommendView.vue';
//import SwiperView from './swiper/swiperView.vue';

export default {
  components: { /* BannerView, SwiperView, */ HeadView, HomeView, ProcessView, /* RecommendView, */ FooterView},
  data () {
    return {
      // APP：魔幻轮回、魔卡契约
      appGameData: [
        {
          img: require('@/assets/img/MHLH/icon1-512.png'),
          name: "魔幻轮回",
          route: "/oneGameViewVue"
        },
        {
          img: require('@/assets/img/02MKQY/216.png'),
          name: "魔卡契约",
          route: "/mkqy02GameVue"
        }
      ],
      // Tap：放置：蔚蓝前线
      tapGameData: [
        {
          img: require('@/assets/img/FZWLQX/1.png'),/* "@/assets/img/FZWLQX/1.png",这种无法渲染，模板标签里 :src="@/xxx" 框架自动解析 @，但是JS data 普通字符串不会解析 @别名，浏览器拿到的地址就是原样字符串，直接 404。 */
          name: "放置：蔚蓝前线",
          route: "/fzwlqx03GameVue"
        },
        {
          img: require('@/assets/img/AI02WJZH/1.png'),/* "@/assets/img/FZWLQX/1.png",这种无法渲染，模板标签里 :src="@/xxx" 框架自动解析 @，但是JS data 普通字符串不会解析 @别名，浏览器拿到的地址就是原样字符串，直接 404。 */
          name: "放置：无尽之海",
          route: "/ai02WJZHGameVue"
        },
      ]
    }
  }
}
</script>
<style scoped>
.page-content {
  padding-top: 50px; /* 等于 head-view 的高度 */
}
</style>